export interface FleetServiceModel {
  make: string | null;
  model: string | null;
  vehicleYear: string | null;
  colour: string | null;
  serviceNumber: string | null;
  batteries: string | null;
  serviceState: FleetServiceState;
}

export enum FleetServiceState {
  Proceed = 'Proceed',
  RequireVehicleInfo = 'RequireVehicleInfo',
  Jeopardy = 'Jeopardy',
}
